export default __webpack_public_path__ + "static/media/IV - 2024.becd3337.pdf";